import React from "react";
import { Logo } from "../components/Logo";
import { Linkedin, Twitter, Github, Mail, MapPin } from "lucide-react";

const OFFICES = [
  { city: "Abidjan", country: "Siège · Côte d'Ivoire" },
  { city: "Dakar", country: "Sénégal" },
  { city: "Paris", country: "France" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050a18] text-[#F5F5F5] pt-16 md:pt-20 pb-8 overflow-hidden grain border-t border-[#D4AF37]/15"
    >
      <div className="absolute inset-0 peul-pattern opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10 pb-16 border-b border-[#D4AF37]/15">
          <div className="col-span-2 md:col-span-5">
            <div className="flex items-center gap-3">
              <Logo size={48} variant="light" />
              <div className="leading-none">
                <div className="font-display text-xl font-extrabold tracking-[0.06em]">
                  HAKKILO
                </div>
                <div className="font-display text-[9px] tracking-[0.32em] text-[#D4AF37] font-semibold mt-1">
                  TECHNOLOGIES
                </div>
              </div>
            </div>
            <p className="mt-6 text-[#F5F5F5]/65 text-[15px] leading-relaxed max-w-md">
              <em className="text-[#D4AF37] not-italic font-semibold">Think African. Build Global.</em>{" "}
              <br />
              Solutions technologiques innovantes et sécurisées pour
              accompagner la transformation digitale africaine — depuis 2019.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Linkedin, Twitter, Github, Mail].map((Ic, i) => (
                <a
                  key={i}
                  href={i === 3 ? "mailto:contact@hakkilotechnologie.com" : "#"}
                  data-testid={`footer-social-${i}`}
                  aria-label="social"
                  className="w-10 h-10 inline-flex items-center justify-center border border-[#D4AF37]/25 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors rounded-[2px]"
                >
                  <Ic size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-[#D4AF37] mb-5">Expertises</div>
            <ul className="space-y-3 text-[14px] text-[#F5F5F5]/75">
              <li><a href="#services" className="hover:text-[#D4AF37]">Cybersécurité</a></li>
              <li><a href="#services" className="hover:text-[#D4AF37]">Data & PostgreSQL</a></li>
              <li><a href="#services" className="hover:text-[#D4AF37]">Infrastructure & Cloud</a></li>
              <li><a href="#services" className="hover:text-[#D4AF37]">Intégration de systèmes</a></li>
              <li><a href="#services" className="hover:text-[#D4AF37]">Conseil IT</a></li>
              <li><a href="#services" className="hover:text-[#D4AF37]">Innovation</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-[#D4AF37] mb-5">Société</div>
            <ul className="space-y-3 text-[14px] text-[#F5F5F5]/75">
              <li><a href="#about" className="hover:text-[#D4AF37]">À propos</a></li>
              <li><a href="#secteurs" className="hover:text-[#D4AF37]">Secteurs</a></li>
              <li><a href="#contact" className="hover:text-[#D4AF37]">Contact</a></li>
              <li><a href="/admin" data-testid="footer-admin-link" className="hover:text-[#D4AF37]">Espace admin</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-[#D4AF37] mb-5">Bureaux</div>
            <ul className="space-y-3 text-[14px] text-[#F5F5F5]/75">
              {OFFICES.map((o) => (
                <li key={o.city} className="flex items-start gap-2">
                  <MapPin size={14} className="text-[#D4AF37] mt-0.5 shrink-0" />
                  <div>
                    <div className="font-semibold text-[#F5F5F5]">{o.city}</div>
                    <div className="text-[12px] text-[#F5F5F5]/55">{o.country}</div>
                  </div>
                </li>
              ))}
            </ul>
            <div className="mt-5 text-[12px] text-[#F5F5F5]/70 break-all">
              <a href="mailto:contact@hakkilotechnologie.com" className="hover:text-[#D4AF37]" data-testid="footer-email">
                contact@hakkilotechnologie.com
              </a>
            </div>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="py-10 md:py-12 select-none overflow-hidden">
          <div className="font-display font-black tracking-[-0.02em] text-[#F5F5F5]/[0.06] text-[24vw] md:text-[20vw] leading-[0.85] whitespace-nowrap">
            HAKKILO
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] sm:text-[12px] text-[#F5F5F5]/40">
          <div>
            © {new Date().getFullYear()} Hakkilo Technologies — Tous droits réservés.
            <span className="ml-3 text-[#D4AF37]/70 font-semibold tracking-wider hidden sm:inline">
              AFRICA ROOTED · GLOBAL MINDED
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-1">
            <a href="#" className="hover:text-[#F5F5F5]">Mentions légales</a>
            <a href="#" className="hover:text-[#F5F5F5]">Politique de confidentialité</a>
            <a href="#" className="hover:text-[#F5F5F5]">CGV</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
